export default function QRCode() {
  return {}
}
